<template>
  <div>
    <b-container fluid class="px-0">
      <b-row class="bg-white" no-gutters>
        <b-col cols="12" md="6">
          <b-img
            v-if="isFemale"
            :src="femaleBenefitsImage"
            alt="Benefity Akademia Przyszłości"
            width="669px"
            height="769px"
            class="w-100 h-100 object-fit-cover"
          ></b-img>
          <b-img
            v-else
            :src="maleBenefitsImage"
            alt="Benefity Akademia Przyszłości"
            width="669px"
            height="769px"
            class="w-100 h-100 object-fit-cover"
          ></b-img>
        </b-col>
        <b-col cols="12" md="6" class="px-5 py-5">
          <b-row class="mb-3">
            <b-col cols="12" class="text-blue-500 font-responsive">
              <p class="mt-4 mb-0 mb-lg-2 h2 text-center font-italic">
                {{ $t('childPage.academyBenefits.lead') }}
              </p>
              <p class="h2 font-italic mb-4 text-center" v-orphans>
                {{ $t('childPage.academyBenefits.sublead') }}
              </p>
            </b-col>
          </b-row>
          <b-tabs
            content-class="mt-0"
            fill
            justified
            v-model="tabIndex"
            nav-class="border-0 mb-4 text-blue-500 text-base font-weight-bold
                            align-items-stretch justify-content-center flex-wrap"
            active-nav-item-class="border-top-0 border-left-0 border-right-0
                            border-2 border-mint bg-mint text-blue-500"
          >
            <b-tab
              title-link-class="h-100 d-flex justify-content-center align-items-center
                      academy-benefits-nav"
              :title="$t('childPage.academyBenefits.tab.1')"
            />
            <b-tab
              title-link-class="h-100 d-flex justify-content-center align-items-center
                      academy-benefits-nav"
              :title="$t('childPage.academyBenefits.tab.2')"
            />
            <b-row class="text-blue-500" v-if="tabIndex === 0">
              <b-col
                cols="12"
                class="my-2 px-4"
                v-for="(item, key, index) in academyBenefitsCurrent"
                :key="index"
              >
                <div class="d-flex align-items-start">
                  <b-icon-circle-fill variant="warning-200" class="mr-2 mt-3" font-scale="0.6" />
                  <div class="text-lg font-italic mt-1" v-orphans>
                    {{ $rt(item) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="text-blue-500" v-if="tabIndex === 1">
              <b-col
                cols="12"
                lg="6"
                class="my-2 px-4 font-responsive"
                v-for="(item, key, index) in academyBenefitsFuture"
                :key="index"
              >
                <p class="h2 font-weight-bold">
                  {{ key }}
                  <span class="text-lg font-weight-bold font-italic" v-orphans>
                    {{ $rt(item) }}</span
                  >
                </p>
              </b-col>
            </b-row>
            <b-row align-h="center" class="mt-4" v-if="tabIndex === 1">
              <b-col cols="auto" class="font-responsive">
                <p
                  v-orphans
                  class="text-center border-top border-2 border-mint text-blue-500 text-lg pt-2"
                >
                  {{ $t('childPage.academyBenefits.evaluationResults') }}
                </p>
              </b-col>
            </b-row>
            <b-row align-h="center" class="mt-5" v-if="isPaymentAllowedForChild">
              <b-col cols="auto" v-if="!showHelpButton">
                <p class="text-center text-blue-500 text-lg font-weight-bold">
                  {{ $t('childPage.academyBenefits.hasDonor') }}
                </p>
              </b-col>
              <div class="w-100" v-if="!showHelpButton"></div>
              <b-col cols="12" lg="6" xl="4" class="px-xl-0" v-if="!showHelpButton">
                <router-link :to="{ name: 'Home' }" custom v-slot="{ href, navigate }">
                  <b-button
                    :href="href"
                    @click="navigate"
                    variant="primary"
                    size="lg"
                    block
                    pill
                    class="text-base text-center font-weight-bold"
                  >
                    {{ $t('childPage.seeOtherChildren') }}
                    <i class="angle-right-icon ml-1 bg-white" style="width: 0.5rem"></i>
                  </b-button>
                </router-link>
              </b-col>
              <b-col cols="auto" v-if="showHelpButton">
                <p class="text-center text-blue-500 text-lg font-weight-bold">
                  {{ helpText }}
                </p>
              </b-col>
              <div class="w-100" v-if="showHelpButton"></div>
              <b-col cols="12" lg="6" xl="5" class="px-xl-4 px-lg-0" v-if="showHelpButton">
                <HelpButton class="text-base" :name="childData.first_name_dative"></HelpButton>
              </b-col>
            </b-row>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import HelpButton from '@/components/childPage/HelpButton.vue'

export default {
  name: 'AcademyBenefits',
  props: {
    childData: Object,
    showHelpButton: Boolean,
    female: {
      type: Boolean,
      default: false
    },
    isPaymentAllowedForChild: {
      type: Boolean,
      default: false
    }
  },
  components: {
    HelpButton
  },
  data() {
    return {
      tabIndex: 0,
      academyBenefitsFuture: this.$tm('childPage.academyBenefits.futureBenefits'),
      academyBenefitsCurrent: this.$tm('childPage.academyBenefits.currentBenefits'),
      // skonsultuj z Piotrem:
      femaleBenefitsImage: new URL(
        '/src/assets/images/akademia_przyszlosci_benefits.png',
        import.meta.url
      ).href,
      maleBenefitsImage: new URL('/src/assets/images/ap_chlopiec-z-indeksem.jpeg', import.meta.url)
        .href
    }
  },
  computed: {
    helpText() {
      return this.childData.fundraising && this.childData.fundraising.open
        ? this.$t('childPage.academyBenefits.joinFundraising')
        : this.$t('childPage.academyBenefits.help', { name: this.childGenitive })
    },
    childGenitive() {
      return this.childData.first_name_genitive
        ? this.childData.first_name_genitive
        : this.$t('childPage.childGenitive')
    },
    isFemale() {
      return this.childData?.gender?.value === 'female'
    }
  }
}
</script>
